import Cookies from "universal-cookie";

import { HRBackEndUrl } from "../config";

export const loginHRSite = async (logged) => {
  const cookies = new Cookies();

  const domain = process.env.REACT_APP_FRONTEND_URL.includes("localhost")
    ? undefined
    : process.env.REACT_APP_INVEX_DOMAIN;

  const {
    user: { email, password },
    backendApi,
  } = logged;

  try {
    const response = await fetch(`${HRBackEndUrl}/users/signIn`, {
      method: "POST",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ username: email, password, backendApi }),
    });

    if (!response.ok) throw new Error("Login failed");

    const responseJson = await response.json();
    const { success, user, branch } = responseJson;

    if (!success || !user) return;

    // 🍪 Shared cookie options
    const expires = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000);
    const cookieOptions = {
      path: "/",
      expires,
      ...(domain ? { domain } : {}),
    };

    // 🍪 Helper to set cookie
    const setCookie = (name, value) => cookies.set(name, value, cookieOptions);

    // ✅ Set required cookies
    setCookie("isLoggedIn", true);
    setCookie("userId", user._id);
    setCookie("token", user.token);
    setCookie("isFirstTime", user.isFirstTime);
    setCookie("branch_id", branch);
    setCookie("branch_url", backendApi?.url);
    setCookie("branch_name", backendApi?.name);
    setCookie(
      "company_id",
      user.company_id ?? process.env.REACT_APP_HR_COMPANY
    );

    if (user.isSuperAdmin) {
      setCookie("isSuperAdmin", true);
    } else if (user.isAdmin) {
      setCookie("isAdmin", true);
    }
  } catch (error) {
    console.error("Login error:", error);
  }
};

export const loginHRSiteWaitable = (logged) => {
  return new Promise((resolve, reject) => {
    const domain = process.env.REACT_APP_FRONTEND_URL.includes("localhost")
      ? null
      : process.env.REACT_APP_INVEX_DOMAIN;

    const {
      user: { email, password },
      backendApi,
    } = logged;

    fetch(`${HRBackEndUrl}/users/signIn`, {
      method: "POST",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        username: email,
        password,
        backendApi,
      }),
    })
      .then((response) => {
        if (!response) {
          resolve({ success: false, message: "No response received" });
          return;
        }

        return response.json().then((responseJson) => {
          if (responseJson.success && responseJson.user) {
            const expiryDate = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000);
            const cookies = new Cookies();
            const cookieOptions = {
              path: "/",
              expires: expiryDate,
              ...(domain ? { domain } : {}),
            };

            // Set all cookies with the same options
            const cookieData = {
              isLoggedIn: true,
              userId: responseJson.user._id,
              token: responseJson.user.token,
              isFirstTime: responseJson.user.isFirstTime,
              branch_id: responseJson.branch,
              branch_url: backendApi?.url,
              branch_name: backendApi?.name,
              company_id:
                responseJson.user.company_id ||
                process.env?.REACT_APP_HR_COMPANY,
            };

            // Set user role cookies if applicable
            if (responseJson.user.isSuperAdmin) {
              cookieData.isSuperAdmin = true;
            } else if (responseJson.user.isAdmin) {
              cookieData.isAdmin = true;
            }

            // Set all cookies at once
            Object.entries(cookieData).forEach(([key, value]) => {
              cookies.set(key, value, cookieOptions);
            });

            // Resolve with success data including user info
            resolve({
              success: true,
              user: responseJson.user,
              branch: responseJson.branch,
            });
          } else {
            // Resolve with failure and any error message
            resolve({
              success: false,
              message: responseJson.message || "Login failed",
            });
          }
        });
      })
      .catch((error) => {
        console.error("Login error:", error);
        reject(error);
      });
  });
};
